(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('axios')) :
  typeof define === 'function' && define.amd ? define(['exports', 'axios'], factory) :
  (global = global || self, factory(global.halSDK = {}, global.axios));
}(this, (function (exports, axios) { 'use strict';

  axios = axios && Object.prototype.hasOwnProperty.call(axios, 'default') ? axios['default'] : axios;

  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);

    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);

      if (enumerableOnly) {
        symbols = symbols.filter(function (sym) {
          return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
      }

      keys.push.apply(keys, symbols);
    }

    return keys;
  }

  function _objectSpread2(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};

      if (i % 2) {
        ownKeys(Object(source), true).forEach(function (key) {
          _defineProperty(target, key, source[key]);
        });
      } else if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
      } else {
        ownKeys(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
    }

    return target;
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;

    for (i = 0; i < sourceKeys.length; i++) {
      key = sourceKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }

    return target;
  }

  function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};

    var target = _objectWithoutPropertiesLoose(source, excluded);

    var key, i;

    if (Object.getOwnPropertySymbols) {
      var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

      for (i = 0; i < sourceSymbolKeys.length; i++) {
        key = sourceSymbolKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
      }
    }

    return target;
  }

  var _excluded = ["rel"];

  var getPropertiesFromSchema = function getPropertiesFromSchema() {
    var schema = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var propertiesNode = schema.properties || {};
    return Object.keys(propertiesNode).map(function (key) {
      return _objectSpread2(_objectSpread2({}, propertiesNode[key]), {}, {
        key: key
      });
    });
  };

  var getRequiredFromSchema = function getRequiredFromSchema() {
    var schema = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return schema.required || [];
  };

  var addSchemaProperty = function addSchemaProperty(propertyObject, schema) {
    schema[propertyObject.key] = propertyObject.schema;
  };

  var getInteractionHelpers = function getInteractionHelpers(interaction) {
    var getSchemaProperties = function getSchemaProperties() {
      return getPropertiesFromSchema(interaction.schema);
    };

    var getSchemaProperty = function getSchemaProperty(key) {
      return getSchemaProperties().find(function (property) {
        return property.key === key;
      });
    };

    var hasProperty = function hasProperty(key) {
      return Boolean(getSchemaProperty(key));
    };

    var getRequiredProperties = function getRequiredProperties() {
      return getRequiredFromSchema(interaction.schema);
    };

    var isPropertyRequired = function isPropertyRequired(key) {
      return getRequiredProperties().includes(key);
    };

    var addSchemaProperties = function addSchemaProperties(propertiesAray) {
      interaction.schema = interaction.schema || {};
      interaction.schema.properties = interaction.schema.properties || {};
      propertiesAray.forEach(function (prop) {
        return addSchemaProperty(prop, interaction.schema.properties);
      });
    };

    return {
      getSchemaProperties: getSchemaProperties,
      getSchemaProperty: getSchemaProperty,
      hasProperty: hasProperty,
      getRequiredProperties: getRequiredProperties,
      isPropertyRequired: isPropertyRequired,
      addSchemaProperties: addSchemaProperties,
      addSchemaProperty: addSchemaProperty
    };
  };

  var HalResource = function HalResource(existingRepresentation) {
    var resourceRepresentation = existingRepresentation || {};

    var getTitle = function getTitle() {
      var _resourceRepresentati;

      return (resourceRepresentation === null || resourceRepresentation === void 0 ? void 0 : (_resourceRepresentati = resourceRepresentation._options) === null || _resourceRepresentati === void 0 ? void 0 : _resourceRepresentati.title) || "";
    };

    var getInteractions = function getInteractions() {
      var _resourceRepresentati2;

      return ((resourceRepresentation === null || resourceRepresentation === void 0 ? void 0 : (_resourceRepresentati2 = resourceRepresentation._options) === null || _resourceRepresentati2 === void 0 ? void 0 : _resourceRepresentati2.links) || []).map(function (interaction) {
        return _objectSpread2(_objectSpread2({}, interaction), getInteractionHelpers(interaction));
      });
    };

    var getInteraction = function getInteraction(rel) {
      return getInteractions().find(function (link) {
        return link.rel === rel;
      });
    };

    var getItems = function getItems() {
      var _resourceRepresentati3;

      var itemNode = (resourceRepresentation === null || resourceRepresentation === void 0 ? void 0 : (_resourceRepresentati3 = resourceRepresentation._links) === null || _resourceRepresentati3 === void 0 ? void 0 : _resourceRepresentati3.item) || [];
      return Array.isArray(itemNode) ? itemNode : [itemNode];
    };

    var getItem = function getItem() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      return getItems()[index];
    };

    var getLinks = function getLinks() {
      var linksNode = (resourceRepresentation === null || resourceRepresentation === void 0 ? void 0 : resourceRepresentation._links) || {};
      return Object.keys(linksNode).filter(function (key) {
        return key !== "item";
      }).map(function (key) {
        return _objectSpread2(_objectSpread2({}, linksNode[key]), {}, {
          rel: key
        });
      });
    };

    var getLink = function getLink(rel) {
      return getLinks().find(function (link) {
        return link.rel === rel;
      });
    };

    var getSchemaProperties = function getSchemaProperties() {
      return getPropertiesFromSchema(resourceRepresentation === null || resourceRepresentation === void 0 ? void 0 : resourceRepresentation._options);
    };

    var getSchemaProperty = function getSchemaProperty(key) {
      return getSchemaProperties().find(function (property) {
        return property.key === key;
      });
    };

    var getRequiredProperties = function getRequiredProperties() {
      return getRequiredFromSchema(resourceRepresentation === null || resourceRepresentation === void 0 ? void 0 : resourceRepresentation._options);
    };

    var isPropertyRequired = function isPropertyRequired(key) {
      return getRequiredProperties().includes(key);
    };

    var getPropertyHelpers = function getPropertyHelpers(property) {
      var isRequired = function isRequired() {
        return isPropertyRequired(property);
      };

      var getSchema = function getSchema() {
        return getSchemaProperty(property);
      };

      var existsInInteraction = function existsInInteraction(rel) {
        var _getInteraction;

        return Boolean((_getInteraction = getInteraction(rel)) === null || _getInteraction === void 0 ? void 0 : _getInteraction.hasProperty(property));
      };

      return {
        isRequired: isRequired,
        getSchema: getSchema,
        existsInInteraction: existsInInteraction
      };
    };

    var getProperties = function getProperties() {
      var _resourceRepresentati4;

      return Object.keys((resourceRepresentation === null || resourceRepresentation === void 0 ? void 0 : (_resourceRepresentati4 = resourceRepresentation._options) === null || _resourceRepresentati4 === void 0 ? void 0 : _resourceRepresentati4.properties) || {}).filter(function (key) {
        return key !== "_embedded" && key !== "_options" && key !== "_links";
      }).map(function (key) {
        return _objectSpread2({
          key: key,
          value: resourceRepresentation[key]
        }, getPropertyHelpers(key));
      });
    };

    var getProperty = function getProperty(key) {
      return getProperties().find(function (property) {
        return property.key === key;
      });
    };

    var requiredParam = function requiredParam(param) {
      var requiredParamError = new Error("Required parameter, \"".concat(param, "\" is missing."));
      throw requiredParamError;
    };

    var addLink = function addLink() {
      var link = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : requiredParam("href");
      createLinksSection();

      var rel = link.rel,
          linkWithoutRel = _objectWithoutProperties(link, _excluded);

      rel ? resourceRepresentation._links[rel] = linkWithoutRel : requiredParam("rel");
    };

    var addLinks = function addLinks() {
      var links = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      links.forEach(function (link) {
        addLink(link);
      });
    };

    var addItem = function addItem() {
      var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      item.href || requiredParam("href");
      createItemsArray();

      resourceRepresentation._links.item.push(item);
    };

    var addItems = function addItems() {
      var itemsArray = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      createItemsArray();
      itemsArray.forEach(function (item) {
        addItem(item);
      });
    };

    var addProperty = function addProperty(property) {
      if (property.key !== "_links" && property.key !== "_options" && property.key !== "_embedded") {
        property.key || requiredParam("key");
        property.value || requiredParam("value");
        resourceRepresentation[property.key] = property.value;
      }
    };

    var addProperties = function addProperties() {
      var propertiesAray = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      propertiesAray.forEach(function (prop) {
        addProperty(prop);
      });
    };

    var addOptionsProperties = function addOptionsProperties(propertiesAray) {
      createOptionsPropertiesSection();
      propertiesAray.forEach(function (prop) {
        return addSchemaProperty(prop, resourceRepresentation._options.properties);
      });
    };

    var addOptionsProperty = function addOptionsProperty(propertyObject) {
      createOptionsPropertiesSection();
      addSchemaProperty(propertyObject, resourceRepresentation._options.properties);
    };

    var addTitle = function addTitle(title) {
      createOptionsSection();
      resourceRepresentation._options.title = title;
    };

    var addInteraction = function addInteraction(interaction) {
      createInteractionsSection();
      interaction.rel || requiredParam("rel");
      interaction.href || requiredParam("href");

      resourceRepresentation._options.links.push(interaction);
    };

    var addRequired = function addRequired(required) {
      createOptionsSection();
      resourceRepresentation._options.required = required || [];
    };

    var addOptions = function addOptions() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      createOptionsSection();
      options.links.forEach(function (item) {
        addInteraction(item);
      });
      addOptionsProperties(Array.isArray(options.properties) ? options.properties : [options.properties]);
      addTitle(options.title);
      addRequired(options.required);
    }; // *************************************************************************************** //


    var createOptionsSection = function createOptionsSection() {
      resourceRepresentation._options = resourceRepresentation._options || {};
    };

    var createOptionsPropertiesSection = function createOptionsPropertiesSection() {
      createOptionsSection();
      resourceRepresentation._options.properties = resourceRepresentation._options.properties || {};
    };

    var createInteractionsSection = function createInteractionsSection() {
      createOptionsSection();
      resourceRepresentation._options.links = resourceRepresentation._options.links || [];
    };

    var createLinksSection = function createLinksSection() {
      resourceRepresentation._links = resourceRepresentation._links || {};
    };

    var createItemsArray = function createItemsArray() {
      createLinksSection();
      resourceRepresentation._links.item = resourceRepresentation._links.item || [];
    };

    return {
      resourceRepresentation: resourceRepresentation,
      getTitle: getTitle,
      getInteractions: getInteractions,
      getInteraction: getInteraction,
      getItems: getItems,
      getItem: getItem,
      getLinks: getLinks,
      getLink: getLink,
      getProperties: getProperties,
      getProperty: getProperty,
      getSchemaProperties: getSchemaProperties,
      getSchemaProperty: getSchemaProperty,
      getRequiredProperties: getRequiredProperties,
      addLink: addLink,
      addLinks: addLinks,
      addItem: addItem,
      addItems: addItems,
      addProperty: addProperty,
      addProperties: addProperties,
      addOptionsProperties: addOptionsProperties,
      addOptionsProperty: addOptionsProperty,
      addTitle: addTitle,
      addInteraction: addInteraction,
      addOptions: addOptions
    };
  };

  // Header names
  var CONTENT_TYPE = "content-type";
  var CONTENT_LOCATION = "content-location";
  var LOCATION = "location"; // Media Types

  var HAL_JSON = "application/vnd.hal+json";
  var HAL_JSON2 = "application/hal+json";
  function getType() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        headers = _ref.headers;

    return headers[CONTENT_TYPE] ? headers[CONTENT_TYPE] : null;
  }
  function containsHalResource() {
    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        headers = _ref2.headers;

    return headers && headers[CONTENT_TYPE] ? headers[CONTENT_TYPE].includes(HAL_JSON) || headers[CONTENT_TYPE].includes(HAL_JSON2) ? true : headers[CONTENT_LOCATION] && headers[LOCATION] && headers[CONTENT_LOCATION] === headers[LOCATION] : false;
  }

  function HalResponse(_ref) {
    var body = _ref.body,
        headers = _ref.headers,
        status = _ref.status;
    return {
      headers: headers,
      body: body,
      status: status,
      type: getType({
        headers: headers
      }),
      halResource: HalResource(body),
      containsHalResource: containsHalResource({
        headers: headers
      })
    };
  }

  var globalheaders = {};

  var setGlobalHeaders = function setGlobalHeaders(headers) {
    globalheaders = headers;
  };

  var patch = function patch(_ref) {
    var url = _ref.url,
        body = _ref.body,
        headers = _ref.headers;
    return axios({
      url: url,
      data: body,
      headers: _objectSpread2(_objectSpread2({}, globalheaders), headers),
      method: "patch"
    }).then(function (res) {
      return HalResponse({
        body: res.data,
        headers: res.headers,
        status: res.status
      });
    });
  };

  var get = function get(_ref2) {
    var url = _ref2.url,
        headers = _ref2.headers;
    return axios({
      url: url,
      headers: _objectSpread2(_objectSpread2({}, globalheaders), headers),
      method: "get"
    }).then(function (res) {
      return HalResponse({
        body: res.data,
        headers: res.headers,
        status: res.status
      });
    });
  };

  var post = function post(_ref3) {
    var url = _ref3.url,
        headers = _ref3.headers,
        body = _ref3.body;
    return axios({
      url: url,
      data: body,
      headers: _objectSpread2(_objectSpread2({}, globalheaders), headers),
      method: "post"
    }).then(function (res) {
      return HalResponse({
        body: res.data,
        headers: res.headers,
        status: res.status
      });
    });
  };

  var del = function del(_ref4) {
    var url = _ref4.url,
        headers = _ref4.headers;
    return axios({
      url: url,
      headers: _objectSpread2(_objectSpread2({}, globalheaders), headers),
      method: "delete"
    }).then(function (res) {
      return HalResponse({
        body: res.data,
        headers: res.headers,
        status: res.status
      });
    });
  };

  var halApiCaller = {
    setGlobalHeaders: setGlobalHeaders,
    patch: patch,
    get: get,
    post: post,
    del: del
  };

  exports.HalApiCaller = halApiCaller;
  exports.HalResource = HalResource;
  exports.HalResponse = HalResponse;

  Object.defineProperty(exports, '__esModule', { value: true });

})));
